import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { connect, useDispatch } from 'react-redux'
import { Grid, Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import {
	surveyNavigationSelector
} from '../../../redux/selectors'

import { Paper } from '@material-ui/core'
import CalmButton from '../../../components/CalmButton'
import history from '../../../utilties/history'
import { hideModal } from '../../../redux/actions'

const useStyles = makeStyles((theme) => ({
	containerStyle: {
		padding: '32px',
		[theme.breakpoints.down('sm')]: {
			padding: '0 0 16px',
		},
	},
	buttons: {
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column-reverse',
			alignItems: 'center',
		}
	}

}))

const CompletedSurveyForm = ({
	intl,
	surveyNavigation,
	openNextSurveyPage
}) => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const [hasNextSurvey, setHasNextSurvey] = useState(false)
	
	
	useEffect(
		() => {
			setHasNextSurvey(
				!!surveyNavigation?.nextCaseId
				&& !!surveyNavigation?.nextProtocolId
				&& !!surveyNavigation?.nextSurveyInstanceId
				&& !!surveyNavigation?.nextSurveyId
			)

			if (!surveyNavigation?.surveyIsCompleted) {
				dispatch(hideModal())
			}
		},
		[surveyNavigation]
	)

	const handleOpenNextSurvey = () => {
		if (
			hasNextSurvey
			&& openNextSurveyPage
		) {
			openNextSurveyPage(
				surveyNavigation.nextCaseId,
				surveyNavigation.nextProtocolId,
				surveyNavigation.nextSurveyInstanceId,
				surveyNavigation.nextSurveyId
			)
		}
	}

	const openHomePage = () => {
		history.push('/')
	}

	return (
		<Container className="survey-form-page" maxWidth="lg" style={{ marginTop: '3em' }}>
			{
				!!surveyNavigation
				&& <Grid container>
					<Grid className="survey-form-wrapper" item xs={12} sm={11} style={{ margin: '0 auto 40px' }}>
						<Grid
							container
							alignContent="center"
							direction="column"
							spacing={1}
						>
							<Grid
								item
							>
								<Typography
									data-testid="survey-title"
									variant='h2'
									style={{ fontWeight: '400', textAlign: 'center', marginBottom: '32px' }}
								>
									{surveyNavigation.surveyTitle}
								</Typography>
							</Grid>
						</Grid>

						<Grid
							container
							alignContent="center"
							direction="column"
							spacing={1}
							className={classes.containerStyle}
						>
							<Grid
								item
							>
								<Typography
									data-testid="survey-title"
									variant='body1'
									style={{ fontWeight: '400' }}
								>
									{
										intl.formatMessage(
											{
												id: 'app.survey.surveyCompletedLabel'
											},
											{
												surveyTitle: surveyNavigation.nextSurveyTitle,
												protocolName: surveyNavigation.nextProtocolName
											})
									}
								</Typography>
							</Grid>
						</Grid>
						<Grid item>
							<Grid
								container
								justifyContent="center"
								className={classes.buttons}
							>
								<Grid item>
									<CalmButton
										data-testid="form-skip-survey-button"
										variant='outlined'
										color='secondary'
										size='large'
										onClick={openHomePage}
									>
										{intl.formatMessage({ id: 'app.survey.skip' })}
									</CalmButton>
								</Grid>
								{
									!!hasNextSurvey
									&& <Grid item order={{ xs: 1, sm: 2 }}>
										<CalmButton
											data-testid="form-next-survey-button"
											variant='contained'
											color='primary'
											size='large'
											onClick={handleOpenNextSurvey}
										>
											{intl.formatMessage({ id: 'app.survey.nextSurveyButtonLabel' })}
										</CalmButton>
									</Grid>
								}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			}
		</Container>
	)
}

const mapStateToProps = (state, ownProps) => ({
	surveyNavigation: surveyNavigationSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	withRouter
)

export default enhance(CompletedSurveyForm)
